import { VideoSegmentStatus } from '@eagle/data-function-types';
import { FC } from 'react';
import { Icon } from '../icons';

interface Props {
  color: string;
  videoSegmentStatus: VideoSegmentStatus;
}

export const VideoCellIcon: FC<Props> = ({ color, videoSegmentStatus }) => {
  switch (videoSegmentStatus) {
    case VideoSegmentStatus.UPLOAD_COMPLETE:
      return <Icon data-testid="play-icon" icon="Play" style={{ color, fontSize: '1rem' }} />;
    case VideoSegmentStatus.REQUEST_FAILED:
    case VideoSegmentStatus.UPLOAD_FAILED:
      return <Icon data-testid="warning-icon" icon="Warning" style={{ color, fontSize: '1rem' }} />;
    case VideoSegmentStatus.RECORDED:
      return <Icon data-testid="recorded-icon" icon="HardDrive" fontSize="inherit" style={{ color, fontSize: '1rem' }} />;
    case VideoSegmentStatus.UPLOAD_STARTED:
      return <Icon data-testid="upload-icon" icon="Upload" fontSize="inherit" style={{ color, fontSize: '1rem' }} />;
    case VideoSegmentStatus.REQUEST_ACKED:
    case VideoSegmentStatus.REQUESTED:
      return <Icon data-testid="check-icon" icon="Check" fontSize="inherit" style={{ color, fontSize: '1rem' }} />;
    case VideoSegmentStatus.NO_LONGER_AVAILABLE:
    case VideoSegmentStatus.NOT_AVAILABLE:
      return <Icon data-testid="close-icon" icon="CloseIcon" style={{ color, fontSize: '1rem' }} />;
    default:
      return <></>;
  }
};
